import React from "react";
import { Mail, AlertCircle } from "lucide-react";

/**
 * EmailNoticeBanner — Iteration 29
 * High-visibility banner reminding the customer that all post-purchase
 * communication (book, invoice, session updates, reminders) goes via email.
 * Surfaced on the Booking, BookPage, and CheckoutSuccess pages.
 */
const EmailNoticeBanner = ({ className = "" }) => (
  <div
    data-testid="email-notice-banner"
    className={`rounded-2xl border border-[#D9C49A] bg-[#FBF1DC] text-[#5C4520] px-4 py-3 sm:px-5 sm:py-4 leading-relaxed ${className}`}
    role="status"
    dir="rtl"
  >
    <div className="flex items-start gap-3">
      <div className="shrink-0 mt-0.5 inline-flex w-9 h-9 rounded-full bg-white/70 items-center justify-center">
        <Mail className="w-4 h-4 text-[#8A6A1F]" />
      </div>
      <div className="text-sm">
        <div className="flex items-center gap-1.5 font-semibold mb-1 text-[#5C4520]">
          <AlertCircle className="w-4 h-4" />
          ملاحظة هامة
        </div>
        <p className="m-0">
          يرجى متابعة بريدك الإلكتروني وواتساب باستمرار. تصلك تأكيدات وتحديثات
          الجلسة والتذكيرات عبر البريد الإلكتروني و/أو واتساب، بينما تصلك
          الفاتورة والكتاب الرقمي عبر البريد الإلكتروني. يرجى أيضًا التحقق من
          مجلد <strong>Spam</strong>.
        </p>
      </div>
    </div>
  </div>
);

export default EmailNoticeBanner;
